module.exports = __webpack_public_path__ + "static/media/Jackie Bell Vanity (10).c790f96b.JPG";